<template src="./searchComponent.template.html"></template>

<script>
    import moment from "moment-timezone";
    import accounting from "accounting";
    
    export default {
        name: "searchComponent",
        props: ['openSearchPanel', 'persons', 'closeSearchPanel', 'searchPanelObj', 'availableUnits', 'searchAvailabilityCallback'],

        data() {
            return {
                apiUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : ''),
            };
        },
        methods: {
            noUnitsAvailable() {
                let vm = this;
                if (vm.availableUnits && vm.availableUnits.length > 0) {
                    let availableUnitsList = vm.availableUnits.filter(
                    (unit) => unit.Unitactualinventory === 1
                    );
                    console.log("availableUnitsList", availableUnitsList);
                    if (availableUnitsList.length === 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            },  
            addPersons(action){
                var vm = this;
                vm.persons = (action == 'plus') ? (vm.persons+1) : (vm.persons-1);
                //console.log(vm.searchPanelObj.Persons,"<== searchPanelObj.Persons")
                vm.searchAvailabilityCallback(vm.persons);
            },
            closeSearchPanelView() {
                var vm = this;
                vm.closeSearchPanel(false);
            },
            imageURLS(imgGuid) {
                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
            },
            formatFromNightlyCharges(amount) {
                let currency = accounting.formatMoney(amount, {
                    symbol: "$",
                    format: {
                    pos: "%s %v",
                    neg: "%s (%v)",
                    zero: "%s  %v",
                    },
                    thousand: ",",
                    precision: 0,
                    decimal: ".",
                });
                return currency;
            }, 
            selectUnit(unitObj) {
                let vm = this;
                let RatePlanId = vm.searchPanelObj.RatePlanList.filter(
                    obj => obj.id == vm.searchPanelObj.RatePlanValue
                );
                var selectedUnitObj = {
                    ...unitObj,
                    startDate: moment(vm.searchPanelObj.startDate).format("YYYY-MM-DD"),
                    endDate: moment(vm.searchPanelObj.endDate).format("YYYY-MM-DD"),
                    Adults: null,
                    Children: null,
                    Persons: vm.persons,
                    RatePlanId: RatePlanId ? RatePlanId[0].RatePlanId : null,
                    RatePlanName : RatePlanId ? RatePlanId[0].RatePlan_Name : null,
                    selectedRatePlan : RatePlanId
                }
                console.log("selectedUnitObj===>", selectedUnitObj);
                this.$store.dispatch("selectedUnit", {
                    data: {
                        selectedunit: selectedUnitObj,
                    }
                })
                vm.$router.push("/newReservation/" + -1);
            },     
        },
        computed: {
           
        },
        watch: {
            
        },
        mounted() {
            // let vm = this;            
            // $(document).click(function (e) {
            //     console.log("clicked on doc");                
            // })
            this.noUnitsAvailable();
        },
        components: {

        },
    };

</script>